import type { FaireProductEntity } from "../../entity_types/product";

export const p_w3h6xjpvq3: FaireProductEntity = {
  token: "p_w3h6xjpvq3",
  type: "product",
  name: "Candy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/20c56101a018e7589a21696eb94168aa39ab3635bb6695c93aa7f946791f4796.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b710096a26e0f4917b94350e05292a09b068087b2c17e6f5cb525e596f2b881b.jpeg",
    "https://cdn.faire.com/fastly/db3d354b9f9443fcc815d642866cabed80b911c68b9cbb8a7594acb1a24741ff.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/4ef81cac92480825c0d2024e9d3d2793610b378373421e42dc6e255992d6427e.jpeg",
    "https://cdn.faire.com/fastly/69606cdb8248884c3cd5603702d4d55fb05e62fb89b0223bdf9d2b6b5244fcae.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nEveryone either likes candy or they're wrong, it's that simple! Celebrate your sweet treats with a delicious pair of socks*!\n\n*these socks are suh-weet, but not to eat. Generally better to just wear them on your feet.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:24.516Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
